(function () {
  var SHOW_DELAY_MS = 150;
  var SCOPES = { PAGE: "cart-page", DRAWER: "cart-drawer" };

  var counts = { "cart-page": 0, "cart-drawer": 0 };
  var showTimers = { "cart-page": null, "cart-drawer": null };

  var DRAWER_LOADER_STYLES =
    ".hdt-cart-loader{display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.6);pointer-events:none;opacity:0;visibility:hidden;transition:opacity .15s ease,visibility .15s ease;z-index:110}" +
    ".hdt-cart-loader.is-visible{opacity:1;visibility:visible;pointer-events:auto}" +
    ".hdt-cart-loader--drawer{position:absolute;inset:0;border-radius:0}" +
    ".hdt-cart-loader__spinner{width:30px;height:30px;border:3px solid rgba(0,0,0,.08);border-top-color:#4fa8e8;border-radius:50%;animation:hdt-cart-loader-spin .8s linear infinite}" +
    "@keyframes hdt-cart-loader-spin{to{transform:rotate(360deg)}}";

  function getPageLoader() {
    return document.getElementById("hdt-cart-page-loader");
  }

  function getDrawerHost() {
    return document.getElementById("CartDrawer");
  }

  function getDrawerContent() {
    var drawer = getDrawerHost();
    if (!drawer || !drawer.shadowRoot) return null;
    return drawer.shadowRoot.querySelector('[part="content"]');
  }

  function ensureDrawerLoaderStyles(shadowRoot) {
    if (!shadowRoot || shadowRoot.getElementById("hdt-cart-drawer-loader-styles")) return;
    var style = document.createElement("style");
    style.id = "hdt-cart-drawer-loader-styles";
    style.textContent = DRAWER_LOADER_STYLES;
    shadowRoot.appendChild(style);
  }

  function ensureDrawerLoader() {
    var drawer = getDrawerHost();
    if (!drawer || !drawer.shadowRoot) return null;

    ensureDrawerLoaderStyles(drawer.shadowRoot);

    var content = drawer.shadowRoot.querySelector('[part="content"]');
    if (!content) return null;

    var el = content.querySelector("#hdt-cart-drawer-loader");
    if (!el) {
      el = document.createElement("div");
      el.id = "hdt-cart-drawer-loader";
      el.className = "hdt-cart-loader hdt-cart-loader--drawer";
      el.hidden = true;
      el.setAttribute("aria-hidden", "true");
      el.innerHTML =
        '<div class="hdt-cart-loader__spinner" role="status" aria-label="Updating cart"></div>';
      content.appendChild(el);
    }

    return el;
  }

  function isPriceSheetOpen() {
    var sheet = document.getElementById("cart-drawer-price-summary-sheet");
    return !!(sheet && !sheet.hidden);
  }

  function isSuppressed() {
    return isPriceSheetOpen();
  }

  function isDrawerOpen() {
    var drawer = getDrawerHost();
    return !!(drawer && drawer.hasAttribute("open"));
  }

  function getScope(fromElement) {
    if (fromElement && fromElement.closest) {
      if (fromElement.closest("hdt-cart-drawer, #CartDrawer")) {
        return SCOPES.DRAWER;
      }
      if (fromElement.closest("#hdt-page-cart, .hdt-page-cart")) {
        return SCOPES.PAGE;
      }
    }

    if (isDrawerOpen()) {
      return SCOPES.DRAWER;
    }
    if (document.getElementById("hdt-page-cart")) {
      return SCOPES.PAGE;
    }
    return null;
  }

  function getLoaderEl(scope) {
    return scope === SCOPES.DRAWER ? ensureDrawerLoader() : getPageLoader();
  }

  function getAriaTarget(scope) {
    if (scope === SCOPES.DRAWER) {
      var drawer = getDrawerHost();
      if (drawer && drawer.shadowRoot) {
        return drawer.shadowRoot.querySelector('[part="body"]') || drawer;
      }
      return drawer;
    }
    return document.getElementById("hdt-page-cart");
  }

  function showLoader(scope) {
    if (!scope || isSuppressed()) return;

    var el = getLoaderEl(scope);
    if (!el) return;

    el.hidden = false;
    el.classList.add("is-visible");
    el.setAttribute("aria-hidden", "false");

    var target = getAriaTarget(scope);
    if (target) target.setAttribute("aria-busy", "true");
  }

  function hideLoader(scope) {
    if (!scope) return;

    var el = getLoaderEl(scope);
    if (!el) return;

    el.classList.remove("is-visible");
    el.hidden = true;
    el.setAttribute("aria-hidden", "true");

    if (counts[scope] === 0) {
      var target = getAriaTarget(scope);
      if (target) target.removeAttribute("aria-busy");
    }
  }

  function scheduleShow(scope) {
    if (showTimers[scope]) return;

    showTimers[scope] = window.setTimeout(function () {
      showTimers[scope] = null;
      if (counts[scope] > 0) {
        showLoader(scope);
      }
    }, SHOW_DELAY_MS);
  }

  function cancelShow(scope) {
    if (!showTimers[scope]) return;
    clearTimeout(showTimers[scope]);
    showTimers[scope] = null;
  }

  function start(scope, options) {
    options = options || {};
    if (!scope || !Object.prototype.hasOwnProperty.call(counts, scope)) return;
    counts[scope] += 1;
    if (counts[scope] === 1) {
      if (options.delayed) {
        scheduleShow(scope);
      } else {
        cancelShow(scope);
        showLoader(scope);
      }
    }
  }

  function end(scope) {
    if (!scope || !Object.prototype.hasOwnProperty.call(counts, scope)) return;
    counts[scope] = Math.max(0, counts[scope] - 1);
    if (counts[scope] === 0) {
      cancelShow(scope);
      hideLoader(scope);
    }
  }

  function resolveScope(detail) {
    detail = detail || {};
    if (detail.scope === SCOPES.PAGE || detail.scope === SCOPES.DRAWER) {
      return detail.scope;
    }
    if (detail.fromElement) {
      return getScope(detail.fromElement);
    }
    return getScope();
  }

  document.addEventListener("theme:loading:doing", function (event) {
    var scope = resolveScope(event.detail);
    if (scope) {
      start(scope, { delayed: !!(event.detail && event.detail.delayed) });
    }
  });

  document.addEventListener("theme:loading:done", function (event) {
    var scope = resolveScope(event.detail);
    if (scope) end(scope);
  });

  document.addEventListener("cart:drawer:render", function () {
    if (counts[SCOPES.DRAWER] > 0) {
      showLoader(SCOPES.DRAWER);
    }
  });

  document.addEventListener("dialog:afterOpen", function (event) {
    if (event.target && event.target.id === "CartDrawer") {
      ensureDrawerLoader();
    }
  });

  window.HdtCartLoader = {
    start: start,
    end: end,
    getScope: getScope,
    SCOPES: SCOPES,
  };
})();
